import { Button, Card, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { HiOutlineIdentification } from "react-icons/hi";
import { RiPencilFill } from "react-icons/ri";
import InfoPrimaryPatient from "./InfoPrimaryPatient";
import InfoSencondaryPatient from "./InfoSencondaryPatient";
import SendDocPatient from "./SendDocPatient";
import SendEncuetaConsultorio from "./SendEncuetaConsultorio";
import { isConsultorio } from "../../utils/isConsultorio";
import { useContext } from "react";
import { authContext } from "../../context/AuthContext";

function CardDataClientColombia({t, cita, handleShowEditData, setShowSuccess, setShowModalServer, setErrorServer, noComienza, setOpenConsentimiento}){
    const { patientDTO } = cita
    const {auth} = useContext(authContext)

    return (
        <Card className="shadow-1 my-3">
            <Card.Body>
                <h6>{`${patientDTO.name} ${patientDTO.middleName ?? ''} ${patientDTO?.lastName} ${patientDTO.seccondSurname ?? ''}`}</h6>
                {!noComienza && <Button type="button" variant="outline-info" 
                    className="position-absolute topright-absolute" 
                    size="sm"
                    onClick={handleShowEditData}
                >
                    <RiPencilFill />
                </Button>}
                <Row>
                    <Col xs="8" md="8">
                        <div className="d-flex text-secondary mb-3 font-size-09rem">
                            <div><HiOutlineIdentification className="mr-2"/></div>
                            <div><span>{patientDTO?.identityDocumentType?.code}: {patientDTO.documentNumber}</span></div>                                            
                        </div>
                        <InfoPrimaryPatient paciente={patientDTO} cita={cita}/>                        
                    </Col>
                    <Col xs="4" md="4">
                        <InfoSencondaryPatient paciente={patientDTO} cita={cita}/>
                    </Col>
                    <Col xs="12" md="12">
                        <Card>
                            <Card.Body>
                                <label className="text-secondary d-block mb-0">Motivo de consulta</label>
                                <label className="m-0 text-secondary">{`${cita?.motivoConsulta ? cita.motivoConsulta : 'Sin motivo'}`}</label>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
               {!noComienza && <SendDocPatient cita={cita} setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}/>}
               <SendEncuetaConsultorio noComienza={noComienza} cita={cita} setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}/>
               {/* {setOpenConsentimiento && isConsultorio(auth.data.role) && 
               <Button type="button" 
                    size="sm" 
                    variant="link"
                    onClick={() => setOpenConsentimiento(true)}
                >
                    Consentimiento informado
                </Button>} */}
            </Card.Body>
        </Card>
    )
}

export default withTranslation()(CardDataClientColombia)